export const translationDictionary: { [lang: string]: { [key: string]: string } } = {
    en: {
        'PIN_VERIFICATION': 'PIN Verification',
        'PROVIDE_PIN': 'Please provide this PIN to your agent to confirm:',
        'AUTO_REFRESH': 'This page will auto refresh for collection of data.',
        'SECURE_DATA_ENTRY': 'Secure Data Entry',
        'PERSONAL_INFORMATION': 'Personal Information',
        'CUSTOMER_CONSENT': 'Customer\'s Consent',
        'FIRST_NAME': 'First Name',
        'LAST_NAME': 'Last Name',
        'SERVICE_ADDRESS': 'Service Address',
        'STREET_ADDRESS': 'Street Address',
        'SERVICE_ADDRESS_AS_BILLING_ADDRESS': 'Your Service Address will be used as your Billing Address:',
        'USE_SERVICE_ADDRESS': 'Use Service Address',
        'CITY': 'City',
        'STATE': 'State',
        'ZIP_CODE': 'Zip Code',
        'CREATE_PASSCODE': 'Create Passcode',
        'CREATE_PASSCODE_SECURE': 'To keep your account as secure as possible, a passcode is required to be created.',
        'CREATE_PASSCODE_REQ': 'Passcode must be between 6 and 8 digits long',
        'ENTER_VALID_FIRST_NAME': 'Please enter a valid First Name',
        'ENTER_VALID_LAST_NAME': 'Please enter a valid Last Name',
        'ENTER_VALID_CITY': 'Please enter a valid City',
        'SELECT_VALID_STATE': 'Please select a valid State',
        'ENTER_VALID_ZIP': 'Please enter a valid Zip Code',
        'ENTER_ADDRESS': 'Enter Address',
        'PO_BOX_NOT_ALLOWED': 'PO Box addresses are not allowed. Please enter a valid address.',
        'SELECT_STATE': 'Select a state',
        'ENTER_ZIP_CODE': 'Enter zip code',
        'SHOW_FULL_ADDRESS': 'Show full address',
        'TYPE': 'Type',
        'NUMBER': 'Number',
        'SELECT_TYPE': 'Select type',
        'ENTER_NUMBER': 'Enter number',
        'ADD_STRUCTURE_TYPE': 'Add structure type (optional)',
        'STRUCTURE': 'Structure',
        'SELECT_STRUCTURE': 'Select structure',
        'REMOVE': 'Remove',
        'ADD_FLOOR': 'Add floor (optional)',
        'FLOOR_NUMBER': 'Floor #',
        'ENTER_FLOOR_NUMBER': 'Enter floor #',
        'SERVICE_PROVIDER_CONTACT_PERMISSION': 'May the service provider use your contact info to reach you by phone or text with information about your order today?',
        'FIELD_REQUIRED': 'This field is required.',
        'SUBMIT': 'SUBMIT',
        'SEARCH': 'Search',
        'CANCEL': 'CANCEL',
        'CONFIRM': 'CONFIRM',
        'LOCATION_CHECK_REQUIRED': 'Location Check Required',
        'ENABLE_LOCATION_SERVICES': 'Enable Location Services for this site in your device/browser settings, then refresh.',
        'OPEN_BROWSER_SETTINGS': 'OPEN BROWSER SETTINGS',
        'CANCEL_SECURE_DATA': 'Cancel Secure Data',
        'SECURE_DATA_CANCELS_ORDER': 'Cancelling Secure Data will also cancel your order. Continue?',
        'PRIVATE_INFO_SECURITY': 'Private information entered via this secure form will not be visible by the sales agent.',
        'CANCEL_CONFIRMATION_TEXT': 'Are you sure you want to cancel?',
        'CONFIRM_CANCELLATION': 'Confirm Cancellation',
        'CONFIRM_ADDRESS': 'Confirm Address',
        'ADDRESS_CONFIRMATION_QUESTION': 'Are you sure this address is correct?',
        'ICON_LEGEND': 'Icon Legend',
        'PHONE': 'Phone',
        'ENTER_PHONE_NUMBER': 'Enter a phone #',
        'PHONE_VERIFIED_BY_CUSTOMER': 'Phone is verified by customer',
        'PHONE_VERIFIED': 'Phone is verified',
        'PHONE_INVALID': 'Phone is invalid',
        'MOBILE_PHONE': 'Mobile Phone',
        'PHONE_NOT_VERIFIED': 'Phone is not verified',
        'PHONE_NOT_VALID': 'Phone is not valid',
        'VALIDATE_CUSTOMER_PHONE': 'Validate Customer Phone',
        'ENTER_PHONE_OTP_CODE': 'Please enter the six digit code sent to your phone.',
        'EMAIL': 'Email',
        'ENTER_EMAIL': 'Enter email',
        'EMAIL_VERIFIED_BY_CUSTOMER': 'Email is verified by customer',
        'EMAIL_VERIFIED': 'Email is verified',
        'EMAIL_CANNOT_BE_VERIFIED': 'Email cannot be verified',
        'EMAIL_INVALID': 'Email is invalid',
        'EMAIL_NOT_VERIFIED': 'Email is not verified',
        'VALIDATE_CUSTOMER_EMAIL': 'Validate Customer Email',
        'ENTER_EMAIL_OTP_CODE': 'Please enter the six digit code sent to your email.',
        'PAGE_NOT_FOUND': 'This page cannot be found.',
        'ACCOUNT_SECURITY_INFORMATION': 'Account Security Information',
        'PASSCODE_DESCRIPTION': 'Use a 6 to 8 digit passcode to verify your identity when reaching out to us. This passcode isn\'t for account login.',
        'WINDSTREAM_CUSTOMER_ACCOUNT_SETUP': 'Windstream Customer Account Setup',
        'WINDSTREAM_SUBTITLE': 'Provide customer information below.',
        'PASSCODE_LENGTH_REQUIREMENT': 'Your passcode should be 6 to 8 digits in length.',
        'PASSCODE_INFO_TOOLTIP': 'For Authentication purposes, customers are required to set up a 6 to 8 digit passcode and a security question and an answer. This information will be used to verify you whenever you call about your account. Please make a note of this information.',
        'PASSCODE': 'Passcode',
        'ENTER_PASSCODE': 'Enter Passcode',
        'CONFIRM_PASSCODE': 'Confirm Passcode',
        'SECURITY_QUESTION_DESCRIPTION': 'Select a security question and provide an answer to help reset your passcode if needed.',
        'SECURITY_QUESTION': 'Security Question',
        'SECURITY_ANSWER': 'Security Answer',
        'SECURITY_FLAGS_FALSE': 'The securityPin and securityAnswer flags are false.',
        'SELECT_QUESTION': 'Please select your question', 'ORDER_VERIFICATION': 'Order Verification',
        'CONFIRM_DATA_INSTRUCTION': 'Please confirm the data below is correct by checking the box to the left of each item.',
        'COMMENTS_OPTIONAL': 'Comments(Optional)',
        'CLICK_SUBMIT_OR_SELECT_OPTIONS': 'Click Submit, or select other options.',
        'SUBMIT_DESCRIPTION': 'All items above are correct and you would like to complete order.',
        'EDIT_ORDER': 'Edit Order',
        'EDIT_ORDER_DESCRIPTION': 'You need or would like to make changes to the order.',
        'CANCEL_DESCRIPTION': 'You do not want to continue with order at this time.',
        'APPROVE': 'APPROVE',
        'CHANGE': 'CHANGE',
        'FIELD_MUST_BE_CONFIRMED': 'This field must be confirmed.',
        'CONFIRM_PURCHASE_QUESTION': 'Are you sure you want to approve this purchase?',
        'CONFIRM_PURCHASE': 'Confirm Purchase',
        'CONFIRM_CHANGE_QUESTION': 'Are you sure you want to change this purchase?',
        'CONFIRM_EDIT': 'Confirm Edit',
        'CONFIRM_CANCEL_QUESTION': 'Are you sure you want to cancel this purchase?',
        'CREDIT_INFORMATION': 'Credit Information',
        'READ_AND_AGREE': 'I have read and agree to the above.',
        'CUSTOMER_INFORMATION': 'Customer Information',
        'VERIFY_INFORMATION_WARNING': 'Please Verify all the above information is correct, otherwise a new order may have to be started',
        'VERIFIED_INFORMATION': 'The information above is correct',
        'DATE_OF_BIRTH': 'Date of Birth',
        'OPTIONAL': '(optional)',
        'CREDIT_INFORMATION_ON_FILE': 'Your date of birth and SSN/ITIN are already on file.',
        'DATE_FORMAT': 'mm/dd/yyyy',
        'ENTER_VALID_DOB': 'Please enter a valid date of Birth',
        'DOB_FUTURE_ERROR': 'Date of birth cannot be in the future',
        'DOB_AGE_ERROR': 'You must be at least 18 years old.',
        'SOCIAL_SECURITY_NUMBER': 'Social Security Number/ITIN',
        'SSN_FORMAT': '###-##-####',
        'LAST_4_SSN_FORMAT': '####',
        'ENTER_VALID_SSN': 'Please enter a valid SSN/ITIN',
        'LAST_4_SSN': 'Last 4 Social Security Number/ITIN',
        'ENTER_VALID_LAST_4_SSN': 'Please enter a valid last 4 SSN/ITIN',
        'ID_TYPE': 'ID Type',
        'AUTH_USER': 'ID Name',
        'SELECT_AUTH_USER': 'Please select Name',
        'USE_PHOTO_ID': 'Use Photo ID information instead of Social Security Number/ITIN; this may require a call with Customer Service to confirm identity.',
        'ID_TYPE_NOT_HANDLED': 'Id Type not handled',
        'ISSUING_STATE': 'Issuing State',
        'ID_NUMBER': 'ID Number',
        'EXPIRATION_DATE': 'Expiration Date',
        'ENTER_VALID_DATE': 'Please enter a valid date',
        'EXPIRATION_DATE_ERROR': 'Expiration date should be future date',
        'ISSUING_AUTHORITY': 'Issuing Authority',
        'SELECT_COUNTRY': 'Select a country',
        'CHECKBOX': 'Checkbox',
        'ORDER_CHECKLIST': 'Order Checklist',
        'READ_ITEMS_BELOW': 'Please read through the items below.',
        'CONGRATULATIONS_MESSAGE': 'Congratulations on taking advantage of the exclusive AT&T offer. If you have questions about your order, please call 833-603-3270.',
        'CLICK_READ_TERMS': 'Click to read terms and conditions',
        'READ_AND_AGREE_TERMS': 'I have read and agree to the terms.',
        'ELECTRONIC_SIGNATURE': 'Electronic Signature',
        'ESIGN_DISCLOSURE': 'The Electronic Signatures in Global and National Commerce ACT (E-SIGN Act) requires certain disclosures be made to each customer regarding what the customers must have to be able to receive, read, print or store a paperless bill. It also requires that the service provider obtain and retain the customer\'s affirmative consent to provide an electronic signature.',
        'ENTER_FIRST_LAST_NAME': 'Please enter your first and last name',
        'DIGITAL_SIGNATURE_ACKNOWLEDGEMENT': 'By providing my digital signature, I acknowledge that I have read and accept the Terms, Conditions, Disclosures, and/or Agreements detailed above.',
        'MISSING_SELECTIONS': 'Missing selection(s). Please complete all required fields.',
        'ARE_YOU_SURE': 'Are you sure?',
        'EXTERNAL_LINK_WARNING': 'This link will take you to an external website- is that okay?',
        'YES': 'YES',
        'TERMS_AND_CONDITIONS': 'Terms and Conditions',
        'AGREE_TO_TERMS': 'I AGREE',
        'I_ACKNOWLEDGED': 'I ACKNOWLEDGED',
        'COMPLETE_REQUIRED_FIELDS': 'Complete Required Fields',
        'REQUIRED_FIELDS_MESSAGE': 'Please ensure all required fields are complete before proceeding.',
        'OKAY': 'OKAY',
        'AUTO_REFRESH_MESSAGE': 'This page will auto-refresh for collection of additional data.',
        'KEEP_PAGE_OPEN': 'Please keep this page open.',
        'PURCHASE_REQUIRES_ACCEPTANCE': 'Your purchase requires you to accept the terms below.',
        'ATT_BUSINESS_AGREEMENT': 'AT&T Business Agreement',
        'PURCHASE_REQUIRES_AGREEMENT_ACCEPTANCE': 'Your purchase requires you to accept the agreement below.',
        'MBA_CONGRATULATIONS': 'Congratulations on taking advantage of the exclusive AT&T offer. If you have questions about your order, please call 833-603-3270.',
        'ATT_MOBILE_BUSINESS_PRICING_SCHEDULE': 'AT&T Mobile Business Pricing Schedule',
        'ATT_MASTER_AGREEMENT': 'AT&T Multi-Service Agreement (Master Agreement)',
        'MBA_PRICING_SCHEDULE_AGREE_TERMS': 'By checking this box I confirm that I have read and agree to the AT&T Mobile Business Pricing Schedule accessible above (and the included provisions for binding individual arbitration rather than jury trials or class actions), under which the service will auto-renew monthly until cancelled.',
        'MASTER_AGREEMENT_AGREE_TERMS': 'By checking this box I confirm that I have read and agree to the Master Agreement accessible above.',
        'MBA_CANCEL_CONFIRMATION_TEXT': 'Cancelling Secure Data will require the agent to resend the link or cancel the order. Continue?',
        'SUBMIT_SUCCESS_MESSAGE': 'You have successfully submitted your information. Please ask the agent to continue processing your order.',
        'DATA_COLLECTION_CANCELED': 'Secure Data Collection was canceled. Please ask the agent to continue processing your order.',
        'USE_AGENT_ACCESS': 'Application can only be accessed when working with an agent',
        'PAYMENT_INFORMATION': 'Payment Information',
        'IFRAME_PAYMENT_INSTRUCTION': 'Click the "Begin Payment" button below to open a new window and enter your payment information on Windstream site.',
        'IFRAME_PAYMENT_RETURN': 'Please come back to this tab and click the Submit button when you have completed.',
        'BEGIN_PAYMENT': 'BEGIN PAYMENT',
        'HAVING_TROUBLE_VIEWING_PAYMENT': 'Having trouble viewing the payment window?',
        'CLICK_HERE': 'Click here',
        'CONTINUE': 'Continue',
        'EXTERNAL_PAYMENT_HEADER': 'External Payment Window',
        'EXTERNAL_PAYMENT_MESSAGE': 'You will be redirected to an external window to complete your payment. Once completed, please return to this tab to submit your order.',
        'NOTE': 'Note',
        'IFRAME_PAYMENT_NOTE': 'Please make sure to complete the provider payment information before clicking Submit below.',
        'DUE_TODAY': 'Due Today',
        'NO_PAYMENT_DUE_TODAY': 'This order requires no payment at this time.',
        'BILLING_INFORMATION': 'Billing Information',
        'BILLING_ADDRESS': 'Billing Address',
        'PAYMENT_AUTHORIZATION': 'Payment Authorization',
        'READ_TERMS_CONDITIONS': 'Read Terms and Conditions',
        'AGREE_PAYMENT_TERMS': 'I have read and agree to the Payment Terms and Conditions',
        'PAYMENT_AUTHORIZATION_TERMS': 'Payment Authorization Terms & Conditions',
        'PARTIES': 'Parties',
        'PARTIES_DESCRIPTION': 'In this one-time payment authorization, the words "We," "Us" and "Our" mean the Service Provider, and their affiliated companies, and the words "You" and "Your" mean the person providing or designating the Payment Method (as defined below) information and any other person who is authorized to make purchases from Us to be charged to the Payment Method.',
        'ONE_TIME_PAYMENT_AUTH': 'One-Time Payment Authorization',
        'ONE_TIME_PAYMENT_AUTH_DESCRIPTION': 'By manually signing, checking the box or clicking the button next to the link to this authorization during Your transaction with Us today as Your electronic signature, You authorize Us to charge to the Payment Method (1) the amount of Your purchase if You made a purchase today, (2) the total amount outstanding under the Account You designated today or (3) a different amount You specified today to be applied to the designated Account. Your Payment Method could be charged as early as today or on the date You have specified for payment. A late fee may be applied to the Account if You schedule a payment to occur after Your due date. If a charge to Your Payment Method is declined including for insufficient funds, We may re-submit the charge up to the number of times permitted by network rules, and We also reserve the right to undertake further collection action, including imposing costs and fees to the extent permitted by law.',
        'PAYMENT_METHOD': 'Payment Method',
        'PAYMENT_METHOD_DESCRIPTION': '"Payment Method" means the bank account, credit card, debit card or other payment method information (1) You provided to Us during Your transaction today (including by scanning a voided check) including for purposes of this one-time payment authorization or (2) You previously provided to Us that You designated today to be charged under this one-time payment authorization.',
        'REVOCATION': 'Revocation',
        'REVOCATION_DESCRIPTION': 'You may revoke Your authorization by calling the customer care number provided with Your bill, which revocation will take effect if and when the service provider has had a reasonable opportunity to act on it before the payment is processed.',
        'GENERAL': 'General',
        'GENERAL_DESCRIPTION': 'You release Us from any and all claims arising from Your use of this one-time payment service. Please print or save to Your computer, tablet, smartphone or other device a copy of this authorization for Your records.',
        'CLOSE': 'CLOSE',
        'NAME_ON_ACCOUNT': 'Name on Account',
        'ACCOUNT_HOLDER_NAME': 'Account Holder Name',
        'ROUTING_NUMBER': 'Routing Number',
        'ACCOUNT_NUMBER': 'Account Number',
        'CONFIRM_ACCOUNT_NUMBER': 'Confirm Account Number',
        'ATT_INTERNET': 'AT&T Internet',
        'VIASAT': 'Viasat Internet',
        'ATT_WIRELESS': 'AT&T Wireless',
        'ATT_RESIDENTIAL_SATELLITE': 'DIRECTV via Satellite',
        'ATT_VIDEO': 'AT&T Video',
        'COMPLETE': 'COMPLETE',
        'INCOMPLETE': 'INCOMPLETE',
        'PAPERLESS': 'Paperless',
        'ENROLLED': 'Enrolled',
        'AUTOPAY': 'Autopay',
        'DECLINED': 'Declined',
        'AUTOPAY_PAPERLESS_BILLING': 'AutoPay/Paperless Billing',
        'AUTOPAY_DETAILS': 'Autopay Details',
        'AUTOPAY_DETAILS_DESCRIPTION': 'Paperless Billing will be automatically added once Autopay is turned on.',
        'AGREE_TERMS_FOR_DISCOUNT': 'You must agree to the three terms to qualify for the discount.',
        'PAPERLESS_BILLING_DISCLOSURES': 'Paperless Billing Disclosures',
        'AGREE_PAPERLESS_BILLING': 'I have read and agree to Paperless Billing Disclosures',
        'AUTOPAY_ENROLLMENT': 'Autopay Enrollment',
        'SETUP_AUTOPAY_PAPERLESS_BILLING': 'Set up Autopay & Paperless Billing',
        'WANT_TO_OPT_OUT': 'Want to opt out?',
        'AUTOPAY_OPT_OUT_DESCRIPTION': 'Selected in previous steps. To opt the customer out, return to the previous page or restart the order if already approved.',
        'AUTOPAY_TERMS_AND_CONDITIONS': 'AutoPay Terms and Conditions',
        'OOF_AUTOPAY_CONSENT': 'I have read the above to the customer and they agree to the terms.',
        'USE_SAME_PAYMENT_AS_TODAYS_CHARGES': 'Use the same payment method as Today\'s Charges.',
        'AGREE_AUTOPAY_TERMS': 'I have read and agree to the AutoPay Terms and Conditions',
        'RESIDENTIAL_SATELLITE_AGREE_AUTOPAY_TERMS': 'I agree to the Autopay Terms and Conditions. I understand Autopay will continue automatically unless cancelled at directv.com/myaccount.',
        'RESIDENTIAL_SATELLITE_AGREE_PAPERLESS_BILLING': 'I have read and agree to Paperless Billing Disclosures and consent to receive Paperless Billing. ',
        'AUTOPAY_INFORMATION': 'Autopay Information',
        'RESIDENTIAL_SATELLITE_AUTOPAY_INFORMATION': 'Autopay Billing Information',
        'PAY_WITH_ACH': 'Pay with ACH',
        'LAST_NAME_MATCHING_REQUIREMENT': 'The last name on the credit or debit card being used must match the last name of the customer signing up for the service.',
        'USE_SAME_PAYMENT_INFO': 'Use the same payment information',
        'CARDHOLDER_NAME': 'Cardholder Name',
        'ZIP_CODE_MATCH_ERROR': 'Zip code must match the service address zip code',
        'ZIP_CODE_REQUIRED': 'Zip code is required',
        'CARD_NUMBER': 'Card Number',
        'INVALID_CARD_NUMBER': 'Invalid card number. Please check and try again.',
        'CHECKING_CARD_NUMBER': 'Checking card number...',
        'CARD_NUMBER_REQUIRED': 'Card number is required',
        'MM_YYYY': 'mm/yyyy',
        'CARD_EXPIRED': 'Card has expired',
        'INVALID_EXPIRATION_DATE': 'Invalid expiration date',
        'EXPIRATION_DATE_REQUIRED': 'Expiration date is required',
        'CVV': 'CVV',
        'PAST_DUE_BALANCE': 'Past Due Balance',
        'CUSTOMER_BILLING_CALL_INFO': 'The customer can also call AT&T Customer Billing at 800-288-2020.',
        'MUST_AGREE_PAYMENT_TERMS': 'You must agree to the Payment Terms and Conditions',
        'COUPON_CODE': 'Coupon code',
        'ACCOUNT_VERIFICATION': 'Account Verification',
        'PHONE_NUMBER_VERIFY_DESCRIPTION': 'Enter phone number to verify account.',
        'OTP_DESCRIPTION':'To finish accessing the account, a one-time PIN or the account passcode must be entered. Please select an option to continue.',
        'ATT_PHONE_NUMBER_FIELD': 'AT&T Phone Number',
        'ATT_BILLING_ZIP_FIELD': 'AT&T Billing Zip Code',
        'Last_4_SSN': 'Last 4 of SSN/ITIN',
        'ONE_TIME_PIN_FIELD': 'One-time PIN',
        'PIN_TYPE': 'PIN Type',
        'ONE_TIME_PIN': 'One-time PIN',
        'ACCOUNT_PASSCODE': 'Account Passcode',
        'VERIFY_ACCOUNT': 'Verify Account',
        'PLEASE_FILL_OUT_INFORMATION': 'Please fill out the information to proceed.',
        'BUSINESS_INFORMATION': 'Business Information',
        'BUSINESS_NAME': 'Business Name',
        'ENTER_BUSINESS_NAME': 'Enter business name',
        'BUSINESS_TYPE': 'Business Type',
        'SELECT_ONE': 'Select one',
        'EIN_TAX_ID': 'EIN / Tax ID',
        'ENTER_TAX_ID': 'Enter tax ID',
        'ENTER_VALID_TAX_ID': 'Please enter a valid EIN / Tax ID',
        'WIRELESS_ACCOUNT_AUTHENTICATION_TITLE': 'Wireless Account Authentication',
        'WIRELESS_ACCOUNT_AUTHENTICATION_SUBTEXT': 'Verify your identity in three steps below.',
        'STEP_1_OF_3': 'Step 1',
        'STEP_2_OF_3': 'Step 2',
        'STEP_3_OF_3': 'Step 3',
        'FIND_AND_VALIDATE_ACCOUNT': 'Find & Validate Account',
        'ACCOUNT_VALIDATED': 'Account validated',
        'MOBILE_NUMBER_FIELD': 'Mobile Number',
        'FAN_NUMBER_FIELD': 'FAN Number',
        'FAN_PIN_FIELD': 'FAN PIN',
        'VALIDATE_ACCOUNT': 'Validate Account',
        'ACCOUNT_DETAILS': 'Account Details',
        'CLEAR_SELECTION': 'Clear Selection',
        'CLEAR_SELECTION_CONFIRMATION_TEXT': 'This will remove all entered account details including mobile number, FAN number, and FAN PIN. You will need to re-enter this information. Continue?',
        'SEND_ONE_TIME_PIN': 'Send One-Time Pin (OTP)',
        'OTP_REQUIRED_DESCRIPTION': 'A One-Time Pin (OTP) is required for account access.',
        'SEND_PIN_VIA': 'Send Pin via:',
        'SEND_PIN': 'Send Pin',
        'VALIDATE_PIN': 'Validate Pin',
        'WHAT_IS_IT': 'What is it?',
        'FAN_NUMBER_INFO_DESCRIPTION': 'FAN Number (Foundation Account Number) is a unique identifier assigned to your discount profile. It can be found on the top right corner of your AT&T bill (labeled "Foundation Account" or "FAN").',
        'FAN_PIN_INFO_DESCRIPTION': 'FAN PIN is a security code used to authenticate your account. If you do not remember it, you can reset it at',
        'ACCOUNT_NOT_VALIDATED_TITLE': 'Account not validated',
        'ACCOUNT_NOT_VALIDATED_MESSAGE': 'The mobile number, FAN number, and/or FAN PIN do not match. Check the details below and try again.',
        'PIN_EXPIRED_TITLE': 'Pin expired',
        'PIN_EXPIRED_MESSAGE': 'Please resend the Pin and try again.',
        'PIN_NOT_DELIVERED_TITLE': 'Pin not delivered',
        'PIN_NOT_DELIVERED_MESSAGE': 'The Pin could not be delivered to this number. Try a different delivery method.',
        'PIN_INVALID_TITLE': 'Pin could not be validated',
        'PIN_INVALID_MESSAGE': 'Please re-enter the Pin and try again.',
        'CONNECTION_ERROR_TITLE': 'Request could not be completed.',
        'CONNECTION_ERROR_MESSAGE': 'Please check your connection and try again. If the problem continues, contact support.',
        'RESEND_PIN': 'Resend Pin',
        'VERIFY_PIN': 'Verify Pin',
        'PIN_SUCCESSFULLY_VALIDATED': 'PIN successfully validated',
        'CODE_SENT_SUCCESS_MESSAGE': 'Code sent to your device',
        'RESEND_COOLDOWN_PREFIX': 'Please wait',
        'RESEND_COOLDOWN_SUFFIX': 'seconds before resending the PIN.',
        'TEXT_SENT_TO_NUMBER_PREFIX': 'A text message has been sent to number ending in',
        'EMAIL_SENT_TO_PREFIX': 'An email message has been sent to',
        'WIRELESS_ACCOUNT_VALIDATION_HEADER': 'Wireless Account Validation',
        'WIRELESS_ACCOUNT_VALIDATION_MESSAGE': 'You have successfully validated your Wireless account.'

    },
    es: {
        'PIN_VERIFICATION': 'Verificación de PIN',
        'PROVIDE_PIN': 'Proporcione este PIN a su agente para confirmar:',
        'AUTO_REFRESH': 'Esta página se actualizará automáticamente para la recopilación de datos.',
        'SECURE_DATA_ENTRY': 'Entrada de Datos Segura',
        'PERSONAL_INFORMATION': 'Información Personal',
        'CUSTOMER_CONSENT': 'Consentimiento del Cliente',
        'FIRST_NAME': 'Nombre',
        'LAST_NAME': 'Apellido',
        'SERVICE_ADDRESS': 'Dirección de Servicio',
        'STREET_ADDRESS': 'Dirección de Calle',
        'SERVICE_ADDRESS_AS_BILLING_ADDRESS': 'Su Dirección de Servicio será utilizada como su Dirección de Facturación:',
        'USE_SERVICE_ADDRESS': 'Usar Dirección de Servicio',
        'CITY': 'Ciudad',
        'STATE': 'Estado',
        'ZIP_CODE': 'Código Postal',
        'CREATE_PASSCODE': 'Crear Código de Contraseña',
        'CREATE_PASSCODE_SECURE': 'Para mantener su cuenta lo más segura posible, se requiere crear un código de acceso.',
        'CREATE_PASSCODE_REQ': 'El código de acceso debe tener entre 6 y 8 dígitos.',
        'ENTER_VALID_FIRST_NAME': 'Por favor ingrese un nombre válido',
        'ENTER_VALID_LAST_NAME': 'Por favor ingrese un apellido válido',
        'ENTER_VALID_CITY': 'Por favor ingrese una ciudad válida',
        'SELECT_VALID_STATE': 'Por favor seleccione un estado válido',
        'ENTER_VALID_ZIP': 'Por favor ingrese un código postal válido',
        'ENTER_ADDRESS': 'Ingrese la dirección',
        'PO_BOX_NOT_ALLOWED': 'No se permiten direcciones de apartado postal (PO Box). Por favor ingrese una dirección válida.',
        'SELECT_STATE': 'Seleccione un estado',
        'ENTER_ZIP_CODE': 'Ingrese código postal',
        'SHOW_FULL_ADDRESS': 'Mostrar dirección completa',
        'TYPE': 'Tipo',
        'NUMBER': 'Número',
        'SELECT_TYPE': 'Seleccione tipo',
        'ENTER_NUMBER': 'Ingrese número',
        'ADD_STRUCTURE_TYPE': 'Agregar tipo de estructura (opcional)',
        'STRUCTURE': 'Estructura',
        'SELECT_STRUCTURE': 'Seleccione estructura',
        'REMOVE': 'Eliminar',
        'ADD_FLOOR': 'Agregar piso (opcional)',
        'FLOOR_NUMBER': 'Piso #',
        'ENTER_FLOOR_NUMBER': 'Ingrese piso #',
        'SERVICE_PROVIDER_CONTACT_PERMISSION': '¿Puede el proveedor de servicios usar su información de contacto para comunicarse con usted por teléfono o mensaje de texto con información sobre su pedido hoy?',
        'FIELD_REQUIRED': 'Este campo es obligatorio.',
        'SUBMIT': 'ENVIAR',
        'SEARCH': 'Buscar',
        'CANCEL': 'CANCELAR',
        'CONFIRM': 'CONFIRMAR',
        'LOCATION_CHECK_REQUIRED': 'Se requiere verificar la ubicación',
        'ENABLE_LOCATION_SERVICES': 'Habilite los servicios de ubicación para este sitio en la configuración de su dispositivo o navegador y, luego, actualice la página.',
        'OPEN_BROWSER_SETTINGS': 'ABRIR CONFIGURACIÓN DEL NAVEGADOR',
        'CANCEL_SECURE_DATA': 'Cancelar datos seguros',
        'SECURE_DATA_CANCELS_ORDER': 'Cancelar los datos seguros también cancelará su pedido. ¿Desea continuar?',
        'PRIVATE_INFO_SECURITY': 'La información privada ingresada a través de este formulario seguro no será visible para el agente de ventas.',
        'CANCEL_CONFIRMATION_TEXT': '¿Está seguro de que desea cancelar?',
        'CONFIRM_CANCELLATION': 'Confirmar Cancelación',
        'CONFIRM_ADDRESS': 'Confirmar Dirección',
        'ADDRESS_CONFIRMATION_QUESTION': '¿Está seguro de que esta dirección es correcta?',
        'EMAIL': 'Correo Electrónico',
        'ENTER_EMAIL': 'Ingrese correo electrónico',
        'EMAIL_VERIFIED_BY_CUSTOMER': 'El correo está verificado por el cliente',
        'EMAIL_VERIFIED': 'El correo está verificado',
        'EMAIL_CANNOT_BE_VERIFIED': 'El correo no puede ser verificado',
        'EMAIL_INVALID': 'El correo no es válido',
        'EMAIL_NOT_VERIFIED': 'El correo no está verificado',
        'VALIDATE_CUSTOMER_EMAIL': 'Validar Correo del Cliente',
        'ENTER_EMAIL_OTP_CODE': 'Por favor ingrese el código de seis dígitos enviado a su correo electrónico.',
        'PHONE': 'Teléfono',
        'ENTER_PHONE_NUMBER': 'Ingrese un número de teléfono',
        'PHONE_VERIFIED_BY_CUSTOMER': 'El teléfono está verificado por el cliente',
        'PHONE_VERIFIED': 'El teléfono está verificado',
        'PHONE_INVALID': 'El teléfono no es válido',
        'MOBILE_PHONE': 'Teléfono Móvil',
        'PHONE_NOT_VERIFIED': 'El teléfono no está verificado',
        'PHONE_NOT_VALID': 'El teléfono no es válido',
        'VALIDATE_CUSTOMER_PHONE': 'Validar Teléfono del Cliente',
        'ENTER_PHONE_OTP_CODE': 'Por favor ingrese el código de seis dígitos enviado a su teléfono.',
        'ICON_LEGEND': 'Leyenda de Iconos',
        'SELECT_QUESTION': 'Por favor seleccione su pregunta',
        'PAGE_NOT_FOUND': 'Esta página no se puede encontrar.',
        'ACCOUNT_SECURITY_INFORMATION': 'Información de Seguridad de la Cuenta',
        'PASSCODE_DESCRIPTION': 'Use un código de acceso de 6 a 8 dígitos para verificar su identidad cuando se comunique con nosotros. Este código de acceso no es para iniciar sesión en la cuenta.',
        'WINDSTREAM_CUSTOMER_ACCOUNT_SETUP': 'Configuración de Cuenta del Cliente de WINDSTREAM',
        'WINDSTREAM_SUBTITLE': 'Proporcione la información personal a continuación.',
        'PASSCODE_LENGTH_REQUIREMENT': 'Su código de acceso debe tener de 6 a 8 dígitos de longitud.',
        'PASSCODE_INFO_TOOLTIP': 'Para fines de autenticación, los clientes deben configurar un código de acceso de 6 a 8 dígitos y una pregunta de seguridad con su respuesta. Esta información se utilizará para verificarlo cada vez que llame sobre su cuenta. Por favor, tome nota de esta información.',
        'PASSCODE': 'Código de Acceso',
        'ENTER_PASSCODE': 'Ingrese Código de Acceso',
        'CONFIRM_PASSCODE': 'Confirmar Código de Acceso',
        'SECURITY_QUESTION_DESCRIPTION': 'Seleccione una pregunta de seguridad y proporcione una respuesta para ayudar a restablecer su código de acceso si es necesario.',
        'SECURITY_QUESTION': 'Pregunta de Seguridad',
        'SECURITY_ANSWER': 'Respuesta de Seguridad',
        'SECURITY_FLAGS_FALSE': 'Las banderas de securityPin y securityAnswer son falsas.',
        'ORDER_VERIFICATION': 'Verificación de Pedido',
        'CONFIRM_DATA_INSTRUCTION': 'Por favor confirme que los datos a continuación son correctos marcando la casilla a la izquierda de cada elemento.',
        'COMMENTS_OPTIONAL': 'Comentarios(Opcional)',
        'CLICK_SUBMIT_OR_SELECT_OPTIONS': 'Haga clic en Enviar o seleccione otras opciones.',
        'SUBMIT_DESCRIPTION': 'Todos los elementos anteriores son correctos y desea completar el pedido.',
        'EDIT_ORDER': 'Editar Pedido',
        'EDIT_ORDER_DESCRIPTION': 'Necesita o desea hacer cambios en el pedido.',
        'CANCEL_DESCRIPTION': 'No desea continuar con el pedido en este momento.',
        'APPROVE': 'APROBAR',
        'CHANGE': 'CAMBIAR',
        'FIELD_MUST_BE_CONFIRMED': 'Este campo debe ser confirmado.',
        'CONFIRM_PURCHASE_QUESTION': '¿Está seguro de que desea aprobar esta compra?',
        'CONFIRM_PURCHASE': 'Confirmar Compra',
        'CONFIRM_CHANGE_QUESTION': '¿Está seguro de que desea cambiar esta compra?',
        'CONFIRM_EDIT': 'Confirmar Edición',
        'CONFIRM_CANCEL_QUESTION': '¿Está seguro de que desea cancelar esta compra?',
        'CREDIT_INFORMATION': 'Información de Crédito',
        'READ_AND_AGREE': 'He leído y acepto lo anterior.',
        'CUSTOMER_INFORMATION': 'Información del Cliente',
        'VERIFY_INFORMATION_WARNING': 'Por favor verifique que toda la información anterior sea correcta, de lo contrario, es posible que se deba iniciar un nuevo pedido',
        'VERIFIED_INFORMATION': 'La información anterior es correcta.',
        'DATE_OF_BIRTH': 'Fecha de Nacimiento',
        'OPTIONAL': '(opcional)',
        'CREDIT_INFORMATION_ON_FILE': 'Su fecha de nacimiento y su SSN/ITIN ya están registrados.',
        'DATE_FORMAT': 'mm/dd/aaaa',
        'ENTER_VALID_DOB': 'Por favor ingrese una fecha de nacimiento válida',
        'DOB_FUTURE_ERROR': 'La fecha de nacimiento no puede ser en el futuro',
        'DOB_AGE_ERROR': 'Debe tener al menos 18 años.',
        'SOCIAL_SECURITY_NUMBER': 'Número de Seguro Social',
        'SSN_FORMAT': '###-##-####',
        'LAST_4_SSN_FORMAT': '####',
        'ENTER_VALID_SSN': 'Por favor ingrese un SSN/ITIN válido',
        'LAST_4_SSN': 'Últimos 4 dígitos del Número de Seguro Social/ITIN',
        'ENTER_VALID_LAST_4_SSN': 'Por favor ingrese los últimos 4 dígitos del SSN/ITIN válidos',
        'ID_TYPE': 'Tipo de Identificación',
        'AUTH_USER': 'Nombre de ID',
        'SELECT_AUTH_USER': 'Seleccione un Nombre',
        'USE_PHOTO_ID': 'Use la información de identificación con foto en lugar del número de Seguro Social; esto puede requerir una llamada con Servicio al Cliente para confirmar su identidad.',
        'ID_TYPE_NOT_HANDLED': 'Tipo de identificación no manejado',
        'ISSUING_STATE': 'Estado Emisor',
        'ID_NUMBER': 'Número de Identificación',
        'EXPIRATION_DATE': 'Fecha de Vencimiento',
        'ENTER_VALID_DATE': 'Por favor ingrese una fecha válida',
        'EXPIRATION_DATE_ERROR': 'La fecha de vencimiento debe ser una fecha futura',
        'ISSUING_AUTHORITY': 'Autoridad Emisora',
        'SELECT_COUNTRY': 'Seleccione un país',
        'CHECKBOX': 'Casilla de verificación',
        'ORDER_CHECKLIST': 'Lista de Verificación del Pedido',
        'READ_ITEMS_BELOW': 'Por favor lea los elementos a continuación.',
        'CONGRATULATIONS_MESSAGE': 'Felicitaciones por aprovechar la oferta exclusiva de AT&T. Si tiene preguntas sobre su pedido, llame al 833-603-3270.',
        'CLICK_READ_TERMS': 'Haga clic para leer los términos y condiciones',
        'READ_AND_AGREE_TERMS': 'He leído y acepto los términos.',
        'ELECTRONIC_SIGNATURE': 'Firma Electrónica',
        'ESIGN_DISCLOSURE': 'La Ley de Firmas Electrónicas en el Comercio Global y Nacional (Ley E-SIGN) requiere que se hagan ciertas divulgaciones a cada cliente con respecto a lo que los clientes deben tener para poder recibir, leer, imprimir o almacenar una factura sin papel. También requiere que el proveedor de servicios obtenga y retenga el consentimiento afirmativo del cliente para proporcionar una firma electrónica.',
        'ENTER_FIRST_LAST_NAME': 'Por favor ingrese su nombre y apellido',
        'DIGITAL_SIGNATURE_ACKNOWLEDGEMENT': 'Al proporcionar mi firma digital, reconozco que he leído y acepto los Términos, Condiciones, Divulgaciones y/o Acuerdos detallados anteriormente.',
        'MISSING_SELECTIONS': 'Faltan selecciones. Por favor complete todos los campos obligatorios.',
        'ARE_YOU_SURE': '¿Está seguro?',
        'EXTERNAL_LINK_WARNING': 'Este enlace lo llevará a un sitio web externo, ¿está de acuerdo?',
        'YES': 'SÍ',
        'TERMS_AND_CONDITIONS': 'Términos y Condiciones',
        'AGREE_TO_TERMS': 'ESTOY DE ACUERDO',
        'I_ACKNOWLEDGED': 'YO RECONOZCO',
        'COMPLETE_REQUIRED_FIELDS': 'Completar Campos Obligatorios',
        'REQUIRED_FIELDS_MESSAGE': 'Por favor asegúrese de que todos los campos obligatorios estén completos antes de continuar.',
        'OKAY': 'ACEPTAR',
        'AUTO_REFRESH_MESSAGE': 'Esta página se actualizará automáticamente para la recopilación de datos adicionales.',
        'KEEP_PAGE_OPEN': 'Por favor mantenga esta página abierta.',
        'PURCHASE_REQUIRES_ACCEPTANCE': 'Su compra requiere que acepte los términos a continuación.',
        'ATT_BUSINESS_AGREEMENT': 'Acuerdo Comercial de AT&T',
        'PURCHASE_REQUIRES_AGREEMENT_ACCEPTANCE': 'Su compra requiere que acepte el acuerdo a continuación.',
        'MBA_CONGRATULATIONS': 'Felicidades por aprovechar la oferta exclusiva de AT&T. Si tiene preguntas sobre su pedido, llame al 833-603-3270.',
        'ATT_MOBILE_BUSINESS_PRICING_SCHEDULE': 'AT&T Mobile Business Pricing Schedule',
        'ATT_MASTER_AGREEMENT': 'AT&T Multi-Service Agreement (Master Agreement)',
        'MBA_PRICING_SCHEDULE_AGREE_TERMS': 'Al marcar esta casilla confirmo que he leído y acepto el AT&T Mobile Business Pricing Schedule accesible arriba (y las disposiciones incluidas para el arbitraje individual vinculante en lugar de juicios con jurado o demandas colectivas), bajo el cual el servicio se renovará automáticamente cada mes hasta que se cancele.',
        'MASTER_AGREEMENT_AGREE_TERMS': 'Al marcar esta casilla confirmo que he leído y acepto el Acuerdo Maestro accesible arriba.',
        'MBA_CANCEL_CONFIRMATION_TEXT': 'Cancelar Secure Data requerirá que el agente reenvíe el enlace o cancele el pedido. ¿Continuar?',
        'SUBMIT_SUCCESS_MESSAGE': 'Ha enviado su información con éxito. Por favor pídale al agente que continúe procesando su pedido.',
        'DATA_COLLECTION_CANCELED': 'La recopilación segura de datos fue cancelada. Por favor pídale al agente que continúe procesando su pedido.',
        'USE_AGENT_ACCESS': 'Solo se puede acceder a la aplicación cuando se trabaja con un agente',
        'PAYMENT_INFORMATION': 'Información de Pago',
        'IFRAME_PAYMENT_INSTRUCTION': 'Haga clic en el botón "Begin Payment" a continuación para abrir una nueva ventana e ingresar su información de pago en el sitio de Windstream.',
        'IFRAME_PAYMENT_RETURN': 'Regrese a esta pestaña y haga clic en el botón Enviar cuando haya terminado.',
        'BEGIN_PAYMENT': 'COMENZAR PAGO',
        'HAVING_TROUBLE_VIEWING_PAYMENT': '¿Tiene problemas para ver la ventana de pago?',
        'CLICK_HERE': 'Haga clic aquí',
        'CONTINUE': 'Continuar',
        'EXTERNAL_PAYMENT_HEADER': 'Ventana de pago externa',
        'EXTERNAL_PAYMENT_MESSAGE': 'Será redirigido a una ventana externa para completar su pago. Una vez completado, regrese a esta pestaña para enviar su pedido.',
        'NOTE': 'Nota',
        'IFRAME_PAYMENT_NOTE': 'Asegúrese de completar la información de pago del proveedor antes de hacer clic en Enviar a continuación.',
        'DUE_TODAY': 'A Pagar Hoy',
        'NO_PAYMENT_DUE_TODAY': 'Este pedido no requiere ningún pago en este momento.',
        'BILLING_INFORMATION': 'Información de Facturación',
        'BILLING_ADDRESS': 'Dirección de Facturación',
        'PAYMENT_AUTHORIZATION': 'Autorización de Pago',
        'READ_TERMS_CONDITIONS': 'Leer Términos y Condiciones',
        'AGREE_PAYMENT_TERMS': 'He leído y acepto los Términos y Condiciones de Pago',
        'PAYMENT_AUTHORIZATION_TERMS': 'Términos y Condiciones de Autorización de Pago',
        'PARTIES': 'Partes',
        'PARTIES_DESCRIPTION': 'En esta autorización de pago único, las palabras "Nosotros" y "Nuestro" significan el Proveedor de Servicios y sus empresas afiliadas, y las palabras "Usted" y "Su" significan la persona que proporciona o designa la información del Método de Pago (como se define a continuación) y cualquier otra persona autorizada a realizar compras que se cargarán al Método de Pago.',
        'ONE_TIME_PAYMENT_AUTH': 'Autorización de Pago Único',
        'ONE_TIME_PAYMENT_AUTH_DESCRIPTION': 'Al firmar manualmente, marcar la casilla o hacer clic en el botón junto al enlace a esta autorización durante Su transacción con Nosotros hoy como Su firma electrónica, Usted nos autoriza a cargar al Método de Pago (1) el monto de Su compra si realizó una compra hoy, (2) el monto total pendiente bajo la Cuenta que designó hoy o (3) un monto diferente que Usted especificó hoy para ser aplicado a la Cuenta designada. Su Método de Pago podría ser cargado tan pronto como hoy o en la fecha que haya especificado para el pago. Se puede aplicar un cargo por pago tardío a la Cuenta si programa un pago para que ocurra después de Su fecha de vencimiento. Si un cargo a Su Método de Pago es rechazado, incluso por fondos insuficientes, podemos volver a enviar el cargo hasta el número de veces permitido por las reglas de la red, y también nos reservamos el derecho de emprender acciones de cobro adicionales, incluida la imposición de costos y tarifas en la medida permitida por la ley.',
        'PAYMENT_METHOD': 'Método de Pago',
        'PAYMENT_METHOD_DESCRIPTION': '"Método de Pago" significa la cuenta bancaria, tarjeta de crédito, tarjeta de débito u otra información del método de pago (1) que Usted nos proporcionó durante Su transacción hoy (incluido el escaneo de un cheque anulado) incluso para fines de esta autorización de pago único o (2) que Usted nos proporcionó previamente y que designó hoy para ser cargado bajo esta autorización de pago único.',
        'REVOCATION': 'Revocación',
        'REVOCATION_DESCRIPTION': 'Puede revocar Su autorización llamando al número de atención al cliente proporcionado con Su factura, cuya revocación surtirá efecto si y cuando el proveedor de servicios haya tenido una oportunidad razonable de actuar antes de que se procese el pago.',
        'GENERAL': 'General',
        'GENERAL_DESCRIPTION': 'Usted nos libera de cualquier reclamación que surja de Su uso de este servicio de pago único. Por favor, imprima o guarde en Su computadora, tableta, teléfono inteligente u otro dispositivo una copia de esta autorización para Sus registros.',
        'CLOSE': 'CERRAR',
        'NAME_ON_ACCOUNT': 'Nombre en la Cuenta',
        'ACCOUNT_HOLDER_NAME': 'Nombre del Titular de la Cuenta',
        'ROUTING_NUMBER': 'Número de Ruta',
        'ACCOUNT_NUMBER': 'Número de Cuenta',
        'CONFIRM_ACCOUNT_NUMBER': 'Confirmar Número de Cuenta',
        'ATT_INTERNET': 'AT&T Internet',
        'VIASAT': 'Viasat Internet',
        'ATT_WIRELESS': 'AT&T Wireless',
        'ATT_RESIDENTIAL_SATELLITE': 'DIRECTV via Satellite',
        'ATT_VIDEO': 'AT&T Video',
        'COMPLETE': 'COMPLETO',
        'INCOMPLETE': 'INCOMPLETO',
        'PAPERLESS': 'Sin Papel',
        'ENROLLED': 'Inscrito',
        'AUTOPAY': 'Pago Automático',
        'DECLINED': 'Rechazado',
        'AUTOPAY_PAPERLESS_BILLING': 'Pago Automático/Facturación Sin Papel',
        'AUTOPAY_DETAILS': 'Detalles de Pago Automático',
        'AUTOPAY_DETAILS_DESCRIPTION': 'La facturación sin papel se agregará automáticamente una vez que se active el Pago Automático.',
        'AGREE_TERMS_FOR_DISCOUNT': 'Debe aceptar los tres términos para calificar para el descuento.',
        'PAPERLESS_BILLING_DISCLOSURES': 'Divulgaciones de Facturación Sin Papel',
        'AGREE_PAPERLESS_BILLING': 'He leído y acepto las Divulgaciones de Facturación Sin Papel',
        'AUTOPAY_ENROLLMENT': 'Inscripción en Pago Automático',
        'SETUP_AUTOPAY_PAPERLESS_BILLING': 'Configurar Pago Automático y Facturación Sin Papel',
        'WANT_TO_OPT_OUT': '¿Desea cancelar la inscripción?',
        'AUTOPAY_OPT_OUT_DESCRIPTION': 'Seleccionado en pasos anteriores. Para cancelar la inscripción del cliente, regrese a la página anterior o reinicie el pedido si ya fue aprobado.',
        'AUTOPAY_TERMS_AND_CONDITIONS': 'Términos y Condiciones de Pago Automático',
        'OOF_AUTOPAY_CONSENT': 'He leído lo anterior al cliente y acepta los términos.',
        'USE_SAME_PAYMENT_AS_TODAYS_CHARGES': 'Usar el mismo método de pago que los Cargos de Hoy.',
        'AGREE_AUTOPAY_TERMS': 'He leído y acepto los Términos y Condiciones del Pago Automático',
        'AUTOPAY_INFORMATION': 'Información de Pago Automático',
        'RESIDENTIAL_SATELLITE_AUTOPAY_INFORMATION': 'Información de Facturación de Pago Automático',
        'PAY_WITH_ACH': 'Pagar con ACH',
        'LAST_NAME_MATCHING_REQUIREMENT': 'El apellido en la tarjeta de crédito o débito que se utiliza debe coincidir con el apellido del cliente que se registra para el servicio.',
        'USE_SAME_PAYMENT_INFO': 'Usar la misma información de pago',
        'CARDHOLDER_NAME': 'Nombre del Titular de la Tarjeta',
        'ZIP_CODE_MATCH_ERROR': 'El código postal debe coincidir con el código postal de la dirección de servicio',
        'ZIP_CODE_REQUIRED': 'El código postal es obligatorio',
        'CARD_NUMBER': 'Número de Tarjeta',
        'INVALID_CARD_NUMBER': 'Número de tarjeta inválido. Por favor verifique e intente nuevamente.',
        'CHECKING_CARD_NUMBER': 'Verificando el número de tarjeta...',
        'CARD_NUMBER_REQUIRED': 'El número de tarjeta es obligatorio',
        'MM_YYYY': 'mm/aaaa',
        'CARD_EXPIRED': 'La tarjeta ha expirado',
        'INVALID_EXPIRATION_DATE': 'Fecha de vencimiento inválida',
        'EXPIRATION_DATE_REQUIRED': 'La fecha de vencimiento es obligatoria',
        'CVV': 'CVV',
        'PAST_DUE_BALANCE': 'Saldo Vencido',
        'CUSTOMER_BILLING_CALL_INFO': 'El cliente también puede llamar a Facturación de Clientes de AT&T al 800-288-2020.',
        'MUST_AGREE_PAYMENT_TERMS': 'Debe aceptar los Términos y Condiciones de Pago',
        'COUPON_CODE': 'Código de cupón',
        "ACCOUNT_VERIFICATION": "Verificación de cuenta",
        "PHONE_NUMBER_VERIFY_DESCRIPTION": "Ingrese el número de teléfono para verificar la cuenta.",
        "OTP_DESCRIPTION": "Para acceder a la cuenta, debe ingresar un PIN de un solo uso o el código de acceso de la cuenta. Seleccione una opción para continuar.",
        "ATT_PHONE_NUMBER_FIELD": "Número de teléfono de AT&T",
        "ATT_BILLING_ZIP_FIELD": "Código postal de facturación de AT&T",
        "Last_4_SSN": "Últimos 4 del SSN/ITIN",
        "ONE_TIME_PIN_FIELD": "PIN de un solo uso",
        "PIN_TYPE": "Tipo de PIN",
        "ONE_TIME_PIN": "PIN de un solo uso",
        "ACCOUNT_PASSCODE": "Código de acceso de la cuenta",
        "VERIFY_ACCOUNT": "Verificar cuenta",
        "PLEASE_FILL_OUT_INFORMATION": "Por favor, complete la información para continuar.",
        "BUSINESS_INFORMATION": "Información del Negocio",
        "BUSINESS_NAME": "Nombre del Negocio",
        "ENTER_BUSINESS_NAME": "Ingrese el nombre del negocio",
        "BUSINESS_TYPE": "Tipo de Negocio",
        "SELECT_ONE": "Seleccione uno",
        "EIN_TAX_ID": "EIN / ID Fiscal",
        "ENTER_TAX_ID": "Ingrese el ID fiscal",
        "ENTER_VALID_TAX_ID": "Ingrese un EIN / ID fiscal válido",
        "WIRELESS_ACCOUNT_AUTHENTICATION_TITLE": "Autenticación de Cuenta Inalámbrica",
        "WIRELESS_ACCOUNT_AUTHENTICATION_SUBTEXT": "Verifique su identidad en los tres pasos a continuación.",
        "STEP_1_OF_3": "Paso 1",
        "STEP_2_OF_3": "Paso 2",
        "STEP_3_OF_3": "Paso 3",
        "FIND_AND_VALIDATE_ACCOUNT": "Buscar y Validar Cuenta",
        "ACCOUNT_VALIDATED": "Cuenta validada",
        "MOBILE_NUMBER_FIELD": "Número de Móvil",
        "FAN_NUMBER_FIELD": "Número FAN",
        "FAN_PIN_FIELD": "PIN FAN",
        "VALIDATE_ACCOUNT": "Validar Cuenta",
        "ACCOUNT_DETAILS": "Detalles de la Cuenta",
        "CLEAR_SELECTION": "Borrar Selección",
        "CLEAR_SELECTION_CONFIRMATION_TEXT": "Esto eliminará todos los detalles de la cuenta ingresados, incluidos el número de móvil, el número FAN y el PIN FAN. Deberá volver a ingresar esta información. ¿Desea continuar?",
        "SEND_ONE_TIME_PIN": "Enviar PIN de un solo uso (OTP)",
        "OTP_REQUIRED_DESCRIPTION": "Se requiere un PIN de un solo uso (OTP) para acceder a la cuenta.",
        "SEND_PIN_VIA": "Enviar PIN por:",
        "SEND_PIN": "Enviar PIN",
        "VALIDATE_PIN": "Validar PIN",
        "WHAT_IS_IT": "¿Qué es esto?",
        "FAN_NUMBER_INFO_DESCRIPTION": "El Número FAN (Número de Cuenta de Fundación) es un identificador único asignado a su perfil de descuento. Se puede encontrar en la esquina superior derecha de su factura de AT&T (etiquetado como \"Foundation Account\" o \"FAN\").",
        "FAN_PIN_INFO_DESCRIPTION": "El PIN FAN es un código de seguridad utilizado para autenticar su cuenta. Si no lo recuerda, puede restablecerlo en",
        "ACCOUNT_NOT_VALIDATED_TITLE": "Cuenta no validada",
        "ACCOUNT_NOT_VALIDATED_MESSAGE": "El número de móvil, el número FAN y/o el PIN FAN no coinciden. Verifique los detalles a continuación e intente nuevamente.",
        "PIN_EXPIRED_TITLE": "El Pin ha expirado",
        "PIN_EXPIRED_MESSAGE": "Por favor, reenvíe el Pin e intente nuevamente.",
        "PIN_NOT_DELIVERED_TITLE": "El Pin no se pudo entregar",
        "PIN_NOT_DELIVERED_MESSAGE": "El Pin no se pudo entregar a este número. Intente con un método de entrega diferente.",
        "PIN_INVALID_TITLE": "El Pin no se pudo validar",
        "PIN_INVALID_MESSAGE": "Por favor, vuelva a ingresar el Pin e intente nuevamente.",
        "CONNECTION_ERROR_TITLE": "No se pudo completar la solicitud.",
        "CONNECTION_ERROR_MESSAGE": "Por favor, verifique su conexión e intente nuevamente. Si el problema continúa, comuníquese con soporte.",
        "RESEND_PIN": "Reenviar Pin",
        "VERIFY_PIN": "Verificar Pin",
        "PIN_SUCCESSFULLY_VALIDATED": "PIN validado con éxito",
        "CODE_SENT_SUCCESS_MESSAGE": "Código enviado a su dispositivo",
        "RESEND_COOLDOWN_PREFIX": "Por favor espere",
        "RESEND_COOLDOWN_SUFFIX": "segundos antes de reenviar el PIN.",
        "TEXT_SENT_TO_NUMBER_PREFIX": "Se ha enviado un mensaje de texto al número que termina en",
        "EMAIL_SENT_TO_PREFIX": "Se ha enviado un mensaje por correo electrónico a",
        "WIRELESS_ACCOUNT_VALIDATION_HEADER": "Validación de Cuenta Inalámbrica",
        "WIRELESS_ACCOUNT_VALIDATION_MESSAGE": "Ha validado con éxito su cuenta inalámbrica."
    }
};
